import { SupplyRaws } from '@factorin/domain';

import { withUrl, list } from '../rest';


const paymentDistributionRawsPart = withUrl('paymentdistributionraws');

export const paymentDistributionRaws = {
    list: list<SupplyRaws.SupplyRaw>(paymentDistributionRawsPart()).list,
};
